
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AboutComponent } from 'app/about/about/about.component';
import { PrivacyPolicyComponent } from 'app/about/privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from 'app/about/terms-of-use/terms-of-use.component';
import { CanActivateViaEmiTokenGuard } from 'app/emi-data.service';
import { LoadingComponent } from 'app/loading/loading.component';
import { EmiBasicResolverService, PortalLaodingResolverService } from 'app/shared/services/emi-basic-resolver.service';
import { realEstateSpecificGloballyPageResolver } from 'app/Real-Estate-Page/services/property.resolver';

const routes: Routes = [
  {
    path: "",
    canActivate: [CanActivateViaEmiTokenGuard],
    canActivateChild: [CanActivateViaEmiTokenGuard],
    children: [
      {
        path: "",
        pathMatch: 'full',
        loadChildren: 'app/home/home.module#HomeModule'
      },
      {
        path: 'loan',
        resolve: {
          jwtToken: EmiBasicResolverService
        },
        loadChildren: 'app/loan/loan-module.module#LoanOffersModule'
      },
      {
        path: 'insurance',
        resolve: {
          jwtToken: EmiBasicResolverService
        },
        loadChildren: 'app/insurance/insurance.module#InsuranceModule'
      },
      {
        path: 'product',
        loadChildren: 'app/products/products.module#ProductsModule'
      },

      {
        path: 'company',
        loadChildren: 'app/company-offers/company-offers.module#CompanyOffersModule'

      },
      {
        path: 'savesalary',
        loadChildren: 'app/savesalary/savesalary.module#SavesalaryModule'
      },
      {
        path: 'credit',
        loadChildren: 'app/credit-limit/credit-limit.module#CreditLimitModule'
      },
     
      {
        path: 'calculator',
        loadChildren: 'app/calculators/calculators-module.module#CalculatorsModule'
      },
      {
        path: 'bank',
        resolve: {
          jwtToken: EmiBasicResolverService
        },
        loadChildren: 'app/bank-offers/bank-offers.module#BankOffersModule'
      },
      {
        path:'real-estate',
        loadChildren:'app/Real-Estate-Page/real-estate.module#RealEstateModule',
        resolve: {
          data: realEstateSpecificGloballyPageResolver
          },
      },
      {
        path:'builder',
        loadChildren:'app/builder-page/builder-module.module#BuilderModule'
      },
      {
        path: 'company-details',
        loadChildren: 'app/company-details/company-details.module#CompanyDetailsModule'
      }
    
    ]
  },
  {
    path: 'loading',
    component: LoadingComponent,
    resolve: {
      basic: PortalLaodingResolverService
    }
  },
  // {
  //   path: 'bank',
  //   loadChildren: 'app/bank-offers/bank-offers.module#BankOffersModule'

  // },

  {
    path: 'pages', component: AboutComponent,
    children: [
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'terms-of-use', component: TermsOfUseComponent },
    ]
  },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [
    CanActivateViaEmiTokenGuard,
    PortalLaodingResolverService,
  ]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/approuting.module.ts